// ===================================================
// File: src/components/ToastContainer/ToastContainer.jsx
// ===================================================
import React from 'react';
import Toast from '../../components/common/Toast';

const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1055 }}>
      {toasts.map(toast => (
        <div key={toast.id} className="mb-2">
          <Toast {...toast} onClose={removeToast} />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;